<h1 mat-dialog-title>Create Product Data File Convention</h1>
<mat-dialog-content class="dialog-body">
  <app-product-data-filename-convention-form
    [initialValue]="seedValue"
    (formValue)="onFormValue($event)"
    (formValid)="onFormValid($event)"
  ></app-product-data-filename-convention-form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    class="create"
    [disabled]="!canCreate"
    (click)="create()"
  >
    Create
  </button>
</mat-dialog-actions>
